import React, { useEffect, useState } from "react";
import { FaFingerprint, FaTrash } from "react-icons/fa";
import "./TabCondoUsersFingerprints.css";
import Button from "../../../../components/Button/Button";
import { ReaderCaptureModal } from "../../../../components/ReaderCaptureModal/ReaderCaptureModal";
import { IoMdFingerPrint } from "react-icons/io";

const fingerMap = {
	1: 'normal1',
	2: 'normal2',
	3: 'panic1',
	4: 'panic2',
}

const TabCondoUsersFingerprints = ({ fingerprints: originalFingerprints, handleChangeFingerprints, ...props }) => {
	const [readerModalState, setReaderModalState] = useState({
		open: false,
		finger: 1,
	});

	const [fingerprints, setFingerprints] = useState({
		normal1: null,
		normal2: null,
		panic1: null,
		panic2: null,
	});

	function updateFingerprints(fingerData, readerModel) {
		setFingerprints(prev => {
			const fpts = {
				...prev,
				[`${fingerMap[readerModalState.finger]}`]: {
					...(prev[`${fingerMap[readerModalState.finger]}`] ?? {}),
					data: fingerData,
					readerModel,
					finger: Number(readerModalState.finger),
				}
			};
			handleChangeFingerprints(Object.values(fpts));
			return fpts;
		});
	}

	useEffect(() => {
		if (
			!fingerprints.normal1 || (fingerprints.normal1.data !== originalFingerprints.find(f => f?.finger === 1)?.data) ||
			!fingerprints.normal2 || (fingerprints.normal2.data !== originalFingerprints.find(f => f?.finger === 2)?.data) ||
			!fingerprints.panic1 || (fingerprints.panic1.data !== originalFingerprints.find(f => f?.finger === 3)?.data) ||
			!fingerprints.panic2 || (fingerprints.panic2.data !== originalFingerprints.find(f => f?.finger === 4)?.data)
		) {
			setFingerprints({
				normal1: originalFingerprints.find(f => f?.finger === 1),
				normal2: originalFingerprints.find(f => f?.finger === 2),
				panic1: originalFingerprints.find(f => f?.finger === 3),
				panic2: originalFingerprints.find(f => f?.finger === 4),
			})
		}
	}, [originalFingerprints]);

	const handleRemove = (finger) => {
		setFingerprints((prev) => {
			const newFingerprints = { ...prev, [finger]: null };
			handleChangeFingerprints(Object.values(newFingerprints).filter(f => f));
			return newFingerprints;
		});
	};

	return (
		<div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
			<div className="fingerprint-container">
				<div className="fingerprint-grid">
					{Object.entries(fingerprints).map(([key, value]) => {
						const isPanic = key.toLowerCase().includes("panic");
						return (
							<div
								key={key}
								className={`fingerprint-box ${isPanic ? "panic" : ""}`}
								title={isPanic ? "Dedo de Pânico ou de Coação" : ""}
							>
								<p className={`text-[15px]! leading-[1.1]!`}>
									{isPanic ? "Dedo Pânico " : "Dedo "}
									{key.replace(/\D/g, "")}
									<br />
									<span className="text-[12px]! inline-flex opacity-70">({value ? 'Capturado' : 'Vazio'})</span>
								</p>
								{value ? (
									<div className="fingerprint-captured">
										<IoMdFingerPrint size={80} className="relative! text-green-400" />
										<Button
											label={"Remover"}
											action="delete"
											className={"button-red"}
											onClick={() => handleRemove(key)}
										/>
									</div>
								) : (
									<div className="fingerprint-placeholder">
										<IoMdFingerPrint size={80} className="relative z-10 **:fill-transparent **:stroke-(--textColor) **:stroke-[8px] opacity-30" />
										<Button
											type="button"
											onClick={() => setReaderModalState({
												open: true,
												finger: Object.entries(fingerMap).find(entry => entry[1] === key)?.[0]
											})}
											label={`Capturar ${isPanic ? "Pânico" : "Dedo"} ${key.replace(/\D/g, "")}`}
										/>
									</div>
								)}
							</div>
						);
					})}
				</div>
			</div>
			<ReaderCaptureModal
				showReaderModal={readerModalState.open}
				setShowReaderModal={(showReaderModal) => {
					setReaderModalState(prev => ({ ...prev, open: showReaderModal }))
				}}
				captureOptions={{
					type: 'finger',
					finger: readerModalState.finger,
				}}
				handleFingerLoaded={updateFingerprints}
			/>
		</div >
	);
};

export default TabCondoUsersFingerprints;
